module.exports = __webpack_public_path__ + "img/57.830ec77c.jpg";